import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";

import type { CheckoutSession } from "@/react/types/Paywalls/Checkout/Session";

interface UseSessionOwnershipParams {
  session: CheckoutSession | null | undefined;
}

interface UseSessionOwnershipReturn {
  isSessionOwnershipValid: boolean;
}

export const useSessionOwnership = ({
  session,
}: UseSessionOwnershipParams): UseSessionOwnershipReturn => {
  const { currentUser, currentCommunityMember } = usePunditUserContext();

  // Simplified validation: only check for mismatches when both sides exist
  // This handles both authenticated flows and post-BNPL flows after sign-in
  const hasUserMismatch =
    !!currentUser && !!session?.user && currentUser.id !== session.user?.id;

  const hasMemberMismatch =
    !!currentCommunityMember &&
    !!session?.community_member &&
    currentCommunityMember.id !== session.community_member?.id;

  const isSessionOwnershipValid = !hasUserMismatch && !hasMemberMismatch;

  return {
    isSessionOwnershipValid,
  };
};
